<template>
  <div>
    <el-table
      :data="detailList"
      stripe
      border
      style="width: 100%"
      header-row-class-name="header_table_row"
    >
      <el-table-column prop="descr" width="120" label="核算科室" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.checkDeskName }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="department"
        label="申请人"
        width="160"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.desk }} {{ scope.row.createBy }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="repairBy" label="申请内容" align="center">
        <template slot-scope="scope">
          <div>
            <div
              v-for="item in scope.row.sysConsumableReceiveDetail"
              :key="item.id"
              style="text-align: left"
            >
              {{ item.brand ? item.brand + "/" : "" }}
              {{ item.inventoryName }}/{{ item.model }}*{{ item.alterNum }}
              {{ item.unit }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="maintainerName"
        width="100"
        label="派送人"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="isException"
        width="100"
        label="工单状态"
        align="center"
      >
        <template slot-scope="scope">
          <div :style="scope.row.isException ? 'color:red' : ''">
            {{ scope.row.isException ? "异常" : "正常" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="80" label="操作" align="center">
        <template slot-scope="scope"
          ><div
            @click="onToInfo(scope.row)"
            style="color: #2d8cf0; cursor: pointer"
          >
            详情
          </div></template
        >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    detailList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.detailList);
  },
  methods: {
    onToInfo(row) {
      this.$Modal.remove();
      $utils.url.push({
        name: "recordInfo",
        query: { action: "edit", kv: row.id },
      });
    },
  },
};
</script>

<style>
</style>